import "../sass/_index.scss";
//import Component_moveImageElement from "./components/moveImageElement";
import Component_ScrollHandler from "./components/scrollHandler";
import Component_toggleLabelPosition from "./components/toggleLabelPosition";

//import Component_ComtactPopup from "./components/contactPopup";

//Component_ComtactPopup();
Component_ScrollHandler();
Component_toggleLabelPosition();
//Component_moveImageElement();
